'use client';

import { c as _c } from "react/compiler-runtime";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import Image from 'next/image';
import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import type { ProjectWalkthrough } from '@/lib/projectsData';
import { cn } from '@/lib/utils';
export function ProjectShowcase(t0) {
  const $ = _c(28);
  const {
    walkthrough,
    name
  } = t0;
  const isWide = walkthrough.format === "desktop";
  const t1 = `${name} in action`;
  let t2;
  if ($[0] !== walkthrough.title) {
    t2 = <h2 className="text-sm font-medium text-zinc-500 dark:text-zinc-400">{walkthrough.title}</h2>;
    $[0] = walkthrough.title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== walkthrough.screens) {
    t3 = walkthrough.screens.map(_temp);
    $[2] = walkthrough.screens;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <TabList aria-label="Choose a screenshot" className="flex flex-wrap gap-1 rounded-2xl bg-zinc-100 p-1 dark:bg-zinc-800/70">{t3}</TabList>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <div className="mb-5 flex flex-wrap items-center justify-between gap-4">{t2}{t4}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isWide || $[10] !== walkthrough.format || $[11] !== walkthrough.screens) {
    let t7;
    if ($[13] !== isWide || $[14] !== walkthrough.format || $[15] !== walkthrough.screens.length) {
      t7 = (screen_0, index_0) => <TabPanel key={screen_0.src} className="focus-visible:rounded-2xl focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-teal-500"><figure className={cn("overflow-hidden rounded-2xl bg-zinc-100 ring-1 ring-zinc-900/5 dark:bg-zinc-800/60 dark:ring-white/10", !isWide && "grid sm:grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)]")}><figcaption className={cn("flex flex-col justify-center p-6 sm:p-8", isWide && "sm:flex-row sm:items-center sm:justify-between sm:gap-10")}><div className={cn(isWide && "max-w-xl")}><p className="mb-3 font-mono text-xs text-zinc-400">0{index_0 + 1} / 0{walkthrough.screens.length}</p><h3 className="text-xl font-semibold tracking-tight text-zinc-900 sm:text-2xl dark:text-zinc-100">{screen_0.heading}</h3><p className="mt-3 text-sm leading-6 text-zinc-600 dark:text-zinc-400">{screen_0.caption}</p></div><a href={screen_0.src} target="_blank" rel="noopener noreferrer" aria-label={`Open full-size screenshot: ${screen_0.label}`} className="mt-5 inline-flex min-h-11 w-fit shrink-0 items-center gap-1 text-xs font-medium text-zinc-500 underline-offset-4 hover:text-zinc-900 hover:underline focus-visible:rounded focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-teal-500 dark:text-zinc-400 dark:hover:text-white">View full size <ArrowUpRightIcon className="size-3" /></a></figcaption><div className={cn("flex items-center justify-center px-5 pb-6 sm:p-6", isWide ? "pt-0 sm:pt-0" : "min-h-[460px] sm:min-h-[540px]")}><Image src={screen_0.src} alt={screen_0.alt} width={screen_0.width} height={screen_0.height} priority={index_0 === 0} unoptimized={true} className={cn("h-auto object-contain", isWide ? "w-full rounded-lg shadow-lg" : walkthrough.format === "phone" ? "max-h-[500px] w-auto max-w-full rounded-[1.75rem] shadow-xl ring-1 ring-black/10" : "max-h-[500px] w-full rounded-xl")} /></div></figure></TabPanel>;
      $[13] = isWide;
      $[14] = walkthrough.format;
      $[15] = walkthrough.screens.length;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    t6 = walkthrough.screens.map(t7);
    $[9] = isWide;
    $[10] = walkthrough.format;
    $[11] = walkthrough.screens;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[17] !== t6) {
    t7 = <TabPanels>{t6}</TabPanels>;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t5 || $[20] !== t7) {
    t8 = <TabGroup>{t5}{t7}</TabGroup>;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== walkthrough.note) {
    t9 = <p className="mt-3 text-xs leading-5 text-zinc-400 dark:text-zinc-500">{walkthrough.note}</p>;
    $[22] = walkthrough.note;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t1 || $[25] !== t8 || $[26] !== t9) {
    t10 = <section aria-label={t1} className="mt-10" id="in-action">{t8}{t9}</section>;
    $[24] = t1;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}
function _temp(screen, index) {
  return <Tab key={screen.src} className="flex min-h-11 items-center gap-2 rounded-xl px-3 text-xs font-medium text-zinc-500 transition-colors hover:text-zinc-900 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500 data-selected:bg-white data-selected:text-zinc-900 data-selected:shadow-sm dark:text-zinc-400 dark:hover:text-white dark:data-selected:bg-zinc-700 dark:data-selected:text-white"><span className="font-mono text-[10px] opacity-60">0{index + 1}</span>{screen.label}</Tab>;
}